module.exports = __webpack_public_path__ + "static/mcdonalds-231b8489167d19e9dc79fb3ec2ebb31c.png";